import { render } from "./VersioneSottoProgetto.vue?vue&type=template&id=45b3fc35&ts=true"
import script from "./VersioneSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./VersioneSottoProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__